import styled from "styled-components";


export const StyledTimerContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
   
`